import { useTranslation } from 'react-i18next';

import NotificationIcon from '@crm/shared/assets/icons/notification-bell.svg?react';
import { SvgIcon } from '@crm/shared/ui';

export const EmptyDealNotes = () => {
    const { t } = useTranslation();

    return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3">
            <SvgIcon size={120} icon={NotificationIcon} />
            <h1 className="m-0 self-stretch text-center text-[18px] leading-6 font-semibold text-gray-800">
                {t('crm.dealDetailsContent.notesBlock.empty.title')}
            </h1>
            <p className="self-stretch text-center text-[13px] leading-4 text-smtr-main-tertiary-100">
                {t('crm.dealDetailsContent.notesBlock.empty.description')}
            </p>
        </div>
    );
};
